<template>
  <!--
    「요금·결제」 창들의 매장 칸 한 곳(요금제 지정 · 매장 체험 — 설계안 3판 §20.5 · §25.4). 매장이 정해져 있으면(상세 창에서 열면) 이름만,
    아니면(목록의 [매장 지정]·[매장 체험]) 매장 선택기(`StorePicker`)로 고른다 — 행이 아직 없는 매장(새 Lite 를 쓴 적 없는 매장)도.
    부모가 경고(`newStoreNotice` — [매장 체험] 창만 준다)를 주면, 선택기에서 고를 때 그 매장의 구독 행을 묻고(`storeRowQueryOf`) 행이 없으면
    그 한 줄을 보인다(10-31 사용자 결정 — 행이 생기고 체험이 끝나면 플러스 기능이 닫힌다). 묻기가 실패하면 경고 없이 그대로다(창 동작을
    막지 않는다).
  -->
  <el-form-item :label="$t(text.grantStoreLabel)" :error="error">
    <span v-if="fixedStoreCd !== null" class="subscription-store-field__fixed" :data-testid="`${testid}-store`">{{
      storeLabel
    }}</span>
    <!--
      창이 열린 뒤에만 그린다(선택기가 그리자마자 범위 트리를 읽는다). 값은 **고른 이벤트(`change`)로만** 받는다(`v-model` 아님): 선택기의
      폴백 입력 칸(el-input-number, 최소 1)은 빈 값을 1 로 채워 보이는데, 그 1 이 고른 매장이 되면 안 된다
    -->
    <StorePicker
      v-else-if="active"
      :value="value"
      fallback="input"
      :auto-select="false"
      :data-testid="`${testid}-picker`"
      @change="pick" />
    <p v-if="showNotice" class="subscription-store-field__notice" :data-testid="`${testid}-new-store`">
      {{ $t(newStoreNotice) }}
    </p>
  </el-form-item>
</template>

<script>
import StorePicker from '@/components/store/StorePicker.vue'
import { LOOKUP_REQUEST_CONFIG } from '@/plugins/http/policy'
import { SUBSCRIPTION_TEXT, hasStoreRow, isStoreCd, storeRowQueryOf } from '@/utils/subscriptionAdmin'

export default {
  name: 'SubscriptionStoreField',

  components: { StorePicker },

  props: {
    /** 정해진 매장(상세 창에서 열 때) — `null` 이면 선택기로 고른다 */
    fixedStoreCd: { type: Number, default: null },
    /** 정해진 매장의 이름(「QA 피자 · S2600…」) */
    storeLabel: { type: String, default: '' },
    /** 선택기에서 고른 매장 — 고르기 전이면 `null` */
    value: { type: Number, default: null },
    /** 창이 열려 있는가 — 열린 뒤에만 선택기를 그린다 */
    active: { type: Boolean, default: false },
    /** 칸 아래 고칠 말 */
    error: { type: String, default: '' },
    /** 고른 매장에 구독 행이 없을 때의 경고(`SUBSCRIPTION_TEXT.newStoreWarning`) — 비면 묻지 않는다 */
    newStoreNotice: { type: String, default: '' },
    /** 시험 id 머리 — `{testid}-store`(정해진 매장) · `{testid}-picker`(선택기) · `{testid}-new-store`(경고) */
    testid: { type: String, required: true },
  },

  data: function () {
    return {
      text: SUBSCRIPTION_TEXT,
      /** 행이 없다고 답이 온 매장 — 지금 고른 매장과 같을 때만 경고를 보인다(다시 고르거나 창을 다시 열면 저절로 사라진다) */
      noRowStoreCd: null,
    }
  },

  computed: {
    showNotice: function () {
      return !!this.newStoreNotice && this.noRowStoreCd !== null && this.noRowStoreCd === this.value
    },
  },

  methods: {
    /** 선택기에서 골랐다 — 부모에 올리고, 그 매장의 구독 행을 묻는다. 답이 왔을 때 다른 매장을 고른 뒤면 버린다 */
    pick: function (storeCd) {
      this.$emit('change', storeCd)
      if (!this.newStoreNotice || !isStoreCd(storeCd)) return

      const query = storeRowQueryOf(storeCd)
      this.$axios
        .get(query.url, Object.assign({ params: query.params }, LOOKUP_REQUEST_CONFIG))
        .then((response) => {
          if (storeCd !== this.value) return
          this.noRowStoreCd = hasStoreRow(response && response.data) ? null : storeCd
        })
        .catch(() => {
          // 부가 조회 — 실패하면 경고 없이 그대로 둔다(토스트도 없다 — LOOKUP_REQUEST_CONFIG)
        })
    },
  },
}
</script>

<style scoped>
.subscription-store-field__fixed {
  font-weight: 500;
  color: var(--color-text-primary);
}

.subscription-store-field__notice {
  margin: 6px 0 0;
  line-height: 1.5;
  color: var(--color-warning);
  word-break: keep-all;
}
</style>
